import {
  getButtonBackgroundHoverColor,
  getHeaderAndNavigationTypography,
  getButtonBackgroundHoverMediumColor
} from 'styles/helpers/getThemeStyles';

const getSecondaryButtonTheme = () => theme => {
  const fontStyles = getHeaderAndNavigationTypography(theme);
  const hoverStyles = {
    color: getButtonBackgroundHoverMediumColor(theme)
  };

  return {
    color: getButtonBackgroundHoverColor(theme),
    '&:hover': {
      ...hoverStyles
    },
    ...fontStyles
  };
};

export function getOwnCartDrawerState() {
  return {
    cartDrawer: getSecondaryButtonTheme()
  };
}

export function getOwnAlertModalButtonState() {
  return {
    alertButton: getSecondaryButtonTheme()
  };
}
